import { Injectable } from '@angular/core';
import { Project } from './project';
import { RatingService } from './rating.service';

@Injectable()
export class RuntimeService {
  private _adminType;
  private _currentProject: Project;
  public ratings: RatingService;

  constructor() { }

  set adminType(tp: string) {
    this._adminType = tp;
  }

  resetAdminType() {
    this._adminType = null;
  }

  evalAdminType(tag: string) {
    return tag == this._adminType;
  }

  get currentProject() {
    return this._currentProject;
  }

  set currentProject(project: Project) {
  //  this.fs.clear()
    if (!this.ratings) {
      return;
    }
    this.ratings.prepareProject(project);
    this._currentProject = project;
    if (project) {
      // this.dbrs.initProjectData(project)
      localStorage.setItem('currentProject', project.id);
    } else
      localStorage.removeItem('currentProject');
  }

  resetCurrentProject() {
    this.currentProject = null;
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/runtime.service.ts